/** @jsx jsx */
import { gql } from '@apollo/client';
import { FormattedText } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function ProductDescription({ product, ...rest }) {
  if (!hasContent(product)) return null;
  return (
    <Section title={<Trans>Description</Trans>} {...rest}>
      <FormattedText
        variant="large"
        text={product.description || product.consumerDescription}
      />
    </Section>
  );
}
ProductDescription.hasContent = hasContent;

function hasContent(product) {
  if (!product) return false;
  if (product.description) return true;
  if (product.consumerDescription) return true;
  return false;
}

export const fragment = graphql`
  fragment bb_ProductDescription on Bottlebooks_Product {
    description
    consumerDescription
  }
`;

ProductDescription.fragment = gql`
  fragment ProductDescription on Product {
    description
    consumerDescription
  }
`;
